import { legacy_createStore as createStore } from 'redux';
import rootReducer from './reducers/rootReducer';

const store = createStore(rootReducer,{},window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__());

export default store;